import hotelDateMockData from "@/libs/client/mocks/hotel/booking/mockHotelBookingRoomDetailResponse.json";

import type { RequestBookingHotelInterface } from "./bookingApiInterface";

class BookingApiService {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "promotion";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************
  async getBookingHotelInfo(params: RequestBookingHotelInterface) {
    const queryParams = new URLSearchParams(params as any);
    if (process.env.NEXT_PUBLIC_MOCK_UP_API === "true") {
      return {
        hotelDateMockData,
        status: 200,
      };
    }
    return {
      data: [{}],
      status: 200,
    };
    // return apiRequest(
    //   this.baseUrl,
    //   `${this.basePath}/promotionLists?${queryParams}`,
    //   "GET",
    // );
  }

  // ******************************************************
  // ****************** Method: POST **********************
  // ******************************************************
}

export default BookingApiService;
